// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9aba6d43","315":"7eae7926","316":"8c0276a2","411":"e03c836f","435":"e5cb54d4","620":"48890533","647":"4def71f2","705":"ba0271e2","788":"f66c6e78","881":"b77da321","900":"eb889f3d","907":"6a00fd1e","922":"173fe895","962":"4a9ac7ee","966":"7e8bc0a2","988":"548474bd"}[chunkId] + ".chunk.js";
};